import { React, useEffect, useState } from "react";
import "./style.scss";
// import Product1 from "../../../../assets/images/tiles-and-porcelain.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faEye,
  faChevronLeft,
  faChevronRight,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import { faHeart as outlineHeart } from "@fortawesome/free-regular-svg-icons";
// import { faStar } from "@fortawesome/free-regular-svg-icons"; // Outlined heart
import { Link, useNavigate } from "react-router-dom";

import { useGetAllProductsQuery, useGetVariantsQuery } from "../../../../services/productsAPI";
import { useGetAllCategoriesQuery } from "../../../../services/productsAPI";
import { faHeart as solidHeart } from "@fortawesome/free-solid-svg-icons";
import {
  useAddToCartMutation,
  useAddToWishlistMutation,
  useGetWishlistQuery,
  useRemoveFromWishlistMutation,
} from "../../../../services/AddToCartAPI";
import { useGetCartCountQuery } from "../../../../services/cartPageAPI";
import { useGetColorThemeQuery } from '../../../../services/commonAPI';
import Loader from "../../fullPageLoader"
import QuickView from "../../quick-view-product"

function Index() {
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const [filter, setFilter] = useState("");
  const [isWishlisted, setIsWishlisted] = useState({}); // Track wishlist status for each product
  const [isOpenQuickViewModal, setHandleShowQuickViewModal] = useState(false);
  const [quickViewId, setQuickViewId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedVariantValues, setselectedVariantValues] = useState([]);
  const { data, error, isLoading } = useGetAllProductsQuery({
    page: currentPage,
    filter,
    categoryId,
    searchTerm,
    selectedVariantValues
  });
  const { data: variants } = useGetVariantsQuery();
  console.log("Variants", variants)
  const {
    refetch: refetchCartCountData
  } = useGetCartCountQuery();
  const navigate = useNavigate();

  const { data: wishlistData } = useGetWishlistQuery(); // Fetch wishlist data
  const [addToCart] = useAddToCartMutation(); // Add to Cart mutation
  const [addToWishlist] = useAddToWishlistMutation(); // Add to Wishlist mutation
  const [removeFromWishlist] = useRemoveFromWishlistMutation(); // RTK Query mutation
  const [showAddToCartMessage, seShowAddToCartMessage] = useState(false);
  const [showWishListMessage, seShowWishListMessage] = useState(false);

  const [activeCategory, setActiveCategory] = useState("all");



  const [openTabs, setOpenTabs] = useState({}); // track open/close status

  const toggleTab = (id) => {
    setOpenTabs((prev) => ({
      ...prev,
      [id]: !prev[id], // toggle open/close
    }));
  };

  const handleValueSelect = (variantId, valueId) => {
    const key = String(valueId);

    setselectedVariantValues((prevSelected) =>
      prevSelected.includes(key)
        ? prevSelected.filter((item) => item !== key)
        : [...prevSelected, key]
    );
  };



  // Check if products are in the wishlist
  useEffect(() => {
    if (wishlistData?.data && data?.data?.products) {
      const wishlistStatus = {};
      data.data.products.forEach((product) => {
        wishlistStatus[product.id] = wishlistData.data.some(
          (item) => item.product.id === product.id
        );
      });
      setIsWishlisted(wishlistStatus);
    }
  }, [wishlistData, data]);

  const {
    data: categoryData,
    error: categoryError,
    isLoading: categoryIsLoading,
  } = useGetAllCategoriesQuery();

  const {
    data: colorthemeData,
  } = useGetColorThemeQuery();

  if (isLoading || categoryIsLoading) return <Loader />;
  if (error || categoryError) return <p>Failed to load Data.</p>;

  // Function to handle adding a product to the cart
  const handleAddToCart = async (product) => {
    const accessToken = localStorage.getItem("access_token");
    // const cartToken = localStorage.getItem("cartToken");

    const hasVariants = product.variants && product.variants.length > 0;
    console.log("Has Variants:", hasVariants);

    if (hasVariants) {
      navigate(`/product-detail/${product.id}`);
    }
    else {
      const attributeId = product.attributes && product.attributes.length > 0 ? product.attributes[0].id : null;
      const payload = {
        product_id: product.id,
        quantity: 1,
        product_attribute_id: attributeId
      };

      // Add user_id only if the user is logged in
      if (accessToken) {
        payload.user_id = localStorage.getItem("gridMarker");
      }

      try {
        const response = await addToCart(payload).unwrap();

        // If the user is a guest and a cart token is returned, store it in localStorage
        if (!accessToken && response.guest_cart_token) {
          localStorage.setItem("cartToken", response.guest_cart_token);
          refetchCartCountData();
        }
        if (response) {
          seShowAddToCartMessage(response.message);
        }
        refetchCartCountData();
        // alert(response.message);
      } catch (err) {
        console.error("Failed to add product to cart:", err);
        alert(err?.data?.message);
      }
    }
  };

  const handleCloseAddCartToast = () => {
    seShowAddToCartMessage(false);
  };

  const handleShowQuickView = (id) => {
    setHandleShowQuickViewModal(true)
    setQuickViewId(id)
  }
  const handlecloseQuikViewMOdal = () => {
    setHandleShowQuickViewModal(false)
  }

  const handleWishlistToggle = async (e, product) => {
    e.preventDefault(); // Prevent link navigation
    const accessToken = localStorage.getItem("access_token");
    const attributeId = product.attributes && product.attributes.length > 0 ? product.attributes[0].id : null;
    const payload = {
      product_id: product.id,
      product_attribute_id: attributeId
    };

    if (accessToken) {
      payload.user_id = localStorage.getItem("gridMarker");
    }

    try {
      if (isWishlisted[product.id]) {
        // Remove from wishlist
        const response = await removeFromWishlist(payload).unwrap();
        setIsWishlisted((prev) => ({ ...prev, [product.id]: false }));
        seShowWishListMessage(response.message);
        refetchCartCountData();
      } else {
        // Add to wishlist
        const response = await addToWishlist(payload).unwrap();
        refetchCartCountData();
        if (!accessToken && response.guest_cart_token) {
          localStorage.setItem("cartToken", response.guest_cart_token);
        }

        setIsWishlisted((prev) => ({ ...prev, [product.id]: true }));
        seShowWishListMessage(response.message);
      }
    } catch (err) {
      console.error("Failed to update wishlist:", err);
      alert(err?.data?.message);
    }
  };

  const handleCloseWishListToast = () => {
    seShowWishListMessage(false);
  };
  // const renderStars = (rating) => {
  //   return (
  //     <div className="stars">
  //       {[...Array(5)].map((_, index) =>
  //         index < rating ? (
  //           <span class="fa fa-star checked"></span>
  //         ) : (
  //           <span class="fa fa-star-o"></span>
  //         )
  //       )}
  //     </div>
  //   );
  // };

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Failed to load Data.</p>;

  // Access the products array from the API response
  const productData = data?.data?.products || [];
  const pagination = data?.data?.pagination || {};

  const handlePageChange = (page) => {
    if (page > 0 && page <= pagination.last_page) {
      setCurrentPage(page);
    }
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const renderPagination = () => {
    const totalPages = pagination.last_page;
    const pageNumbers = [];

    if (totalPages <= 8) {
      // Show all pages if total pages are less than or equal to 8
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Show first 4 pages, ellipsis, and last 4 pages
      if (currentPage <= 4) {
        for (let i = 1; i <= 4; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else if (currentPage >= totalPages - 3) {
        // Show first 4 pages, ellipsis, and last 4 pages
        for (let i = 1; i <= 4; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        // Show first 2 pages, ellipsis, current page and neighbors, ellipsis, and last 2 pages
        pageNumbers.push(1, 2);
        pageNumbers.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        pageNumbers.push(totalPages - 1, totalPages);
      }
    }

    return pageNumbers;
  };

  const handleClickCategory = (id) => {
    console.log("id", id)
    setCategoryId(id);
    setActiveCategory(id);
    setCurrentPage(1);
  }
  const handleSelectAllCategory = () => {
    setCategoryId("");
    setActiveCategory("all");
  }

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    // trigger your search logic here
  };



  return (
    <div className="products">
      <div className="container">
        <div className="product-filter">
          <form>
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div className="input-group">

                  <input
                    type="text"
                    placeholder="Search product"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="form-control search-text-box"
                  />
                  <span className="input-group-text">
                    🔍 {/* or use a proper icon library here */}
                  </span>
                </div>
              </div>

              <div className="col-md-6 col-sm-12 col-lg-6">
                <select onChange={handleFilterChange} value={filter}>
                  <option value="default">Default</option>
                  <option value="price_low_to_high">Price: Low to High</option>
                  <option value="price_high_to_low">Price: High to Low</option>
                  <option value="latest">Latest</option>
                </select>
              </div>
            </div>
          </form>
        </div>
        {showAddToCartMessage && (
          <div className="row mb-4 justify-content-center">
            <div className="col-md-5 col-sm-12 -col-lg-5">
              <div className="d-flex toast-message-add-to-cart m-0">
                <p>{showAddToCartMessage}</p>
                <Link to="/cart-page">
                  <p className="primary-button-link">View Cart Page</p>
                </Link>
                <FontAwesomeIcon
                  icon={faClose}
                  onClick={handleCloseAddCartToast}
                  className="toast-close"
                />
              </div>
            </div>
          </div>
        )}

        {showWishListMessage && (
          <div className="row mb-4 justify-content-center">
            <div className="col-md-5 col-sm-12 -col-lg-5">
              <div className="d-flex toast-message-add-to-wishlist">
                <p>{showWishListMessage}</p>
                <Link to="/wishlist">
                  <p className="primary-button-link">View Wishlist</p>
                </Link>
                <FontAwesomeIcon
                  icon={faClose}
                  onClick={handleCloseWishListToast}
                  className="toast-close"
                />
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-md-3 col-sm-12 col-lg-3">
            <div className="product-categories" style={{ borderLeft: `5px solid ${colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50"}` }} >
              <h4>Categories</h4>
              <ul>
                {categoryData?.data?.length > 0 && (
                  <ul className="p-0">
                    <li
                      onClick={handleSelectAllCategory}
                      style={{
                        color: activeCategory === "all"
                          ? colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50"
                          : "inherit",
                        cursor: "pointer",
                        transition: "color 0.3s ease",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50")}
                      onMouseLeave={(e) => (e.target.style.color = activeCategory === "all" ? colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" : "inherit")}
                    >
                      ALL
                    </li>
                    {categoryData.data.map((category) =>
                      category?.products_count > 0 ? (
                        <li
                          key={category?.id}
                          onClick={() => handleClickCategory(category?.id)}
                          style={{
                            color: activeCategory === category?.id
                              ? colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50"
                              : "inherit",
                            cursor: "pointer",
                            transition: "color 0.3s ease",
                          }}
                          onMouseEnter={(e) => (e.target.style.color = colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50")}
                          onMouseLeave={(e) => (e.target.style.color = activeCategory === category?.id ? colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" : "inherit")}
                        >
                          {category?.category_name} <span>({category?.products_count})</span>
                        </li>
                      ) : null
                    )}

                  </ul>
                )}
              </ul>
            </div>

            <div className="variant-tabs mt-4">
              {variants
                ?.filter((variant) => variant.filter_status === 1)
                .map((variant) => (
                  <div key={variant.id} className="tab">
                    <div className="tab-header" onClick={() => toggleTab(variant.id)}>
                      <span>{variant.name}</span>
                      <button>
                        {openTabs[variant.id] ? "-" : "+"}
                      </button>
                    </div>
                    {openTabs[variant.id] && (
                      <div className="tab-content">
                        {variant?.values?.map((val) => {
                          const key = String(val.id); // 🔥 important
                          const isSelected = selectedVariantValues.includes(key);
                          return (
                            <div key={val.id} className="tab-value">
                              <label className="flex items-center gap-10px">
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={() => handleValueSelect(variant.id, val.id)}
                                />
                                {val.value}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ))}
            </div>



            <div>

            </div>
          </div>
          <div className="col-md-9 col-sm-12 col-lg-9">
            <div className="row">
              {productData.length > 0 ? (
                productData.map((product) => (
                  <div key={product.id} className="col-md-3 col-sm-12 col-lg-3" data-aos="fade-up">
                    <div className="product-img-wrapper">
                      <Link to={`/product-detail/${product.id}`}>
                        <div className="product-item">
                          {product.is_new === 1 && <div className="new-tag">New</div>}

                          {product.discount_percentage > 0 && (
                            <div
                              className="discount-tag"
                              style={{
                                backgroundColor:
                                  colorthemeData?.color_themes?.[0]?.primary_color || "#A76D50",
                              }}
                            >
                              {Math.round(product.discount_percentage)}%
                            </div>
                          )}

                          {product.is_hot === 1 && <div className="hot-tag">hot</div>}

                          <div className="shop-product-img">
                            <img
                              src={product?.product_main_image_url_large}
                              alt={product.product_name}
                              className="img-fluid"
                              loading="lazy"
                            />
                          </div>

                          {/* Hover actions */}
                          <div className="hover-actions product-action-desk">
                            {product?.attributes?.[0]?.stock > 0 && (
                              <button
                                title="Add to Cart"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleAddToCart(product);
                                }}
                              >
                                <FontAwesomeIcon icon={faCartPlus} />
                              </button>
                            )}

                            <button
                              title={
                                isWishlisted[product.id]
                                  ? "Remove from Wishlist"
                                  : "Add to Wishlist"
                              }
                              onClick={(e) => handleWishlistToggle(e, product)}
                              className={`wishlist-btn ${isWishlisted[product.id] ? "wishlisted" : ""
                                }`}
                            >
                              <FontAwesomeIcon
                                icon={isWishlisted[product.id] ? solidHeart : outlineHeart}
                                style={{
                                  color: isWishlisted[product.id] ? "#ff0000" : "inherit",
                                }}
                              />
                            </button>
                            <Link onClick={() => handleShowQuickView(product.id)}>
                              <FontAwesomeIcon icon={faEye} />
                            </Link>
                          </div>
                          {/* ---------- */}
                        </div>
                      </Link>

                      {/* Mobile actions */}
                      <div className="product-action-mob">
                        <div className="d-flex product-action-mob-item">
                          {product?.attributes?.[0]?.stock > 0 && (
                            <p
                              title="Add to Cart"
                              onClick={(e) => {
                                e.preventDefault();
                                handleAddToCart(product);
                              }}
                            >
                              <FontAwesomeIcon icon={faCartPlus} />
                            </p>
                          )}
                          <p
                            title={
                              isWishlisted[product.id]
                                ? "Remove from Wishlist"
                                : "Add to Wishlist"
                            }
                            onClick={(e) => handleWishlistToggle(e, product)}
                            className={`wishlist-btn ${isWishlisted[product.id] ? "wishlisted" : ""
                              }`}
                          >
                            <FontAwesomeIcon
                              icon={isWishlisted[product.id] ? solidHeart : outlineHeart}
                              className={
                                isWishlisted[product.id] ? "wishlist-active" : ""
                              }
                            />
                          </p>
                          <Link onClick={() => handleShowQuickView(product.id)}>
                            <p>
                              <FontAwesomeIcon icon={faEye} />
                            </p>
                          </Link>
                        </div>
                      </div>

                      {/* Product details */}
                      <div>
                        <p
                          className="product-name"
                          style={{
                            color:
                              colorthemeData?.color_themes?.[0]?.heading_color || "#000",
                          }}
                          title={product.product_name}
                        >
                          {product.product_name.length > 20
                            ? `${product.product_name.substring(0, 20)}...`
                            : product.product_name}
                        </p>

                        {product?.total_stock === 0 && (
                          <p className="out-of-stock-text p-0 m-0">(Out of Stock)</p>
                        )}

                        <p
                          className="product-rate p-0 m-0"
                          style={{
                            color:
                              colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
                          }}
                        >
                          {product?.product_price !== product?.selling_price && (
                            <span
                              style={{
                                color:
                                  colorthemeData?.color_themes?.[0]?.text_color_one,
                              }}
                              className="discount-price"
                            >
                              ${product?.product_price}
                            </span>
                          )}{" "}
                          ${product.selling_price}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center py-5">
                  <h5 className="text-black">No products found</h5>
                </div>
              )}
            </div>

          </div>
        </div>
        <div className="pagination">
          {/* Previous Button with Icon */}
          <button
            onClick={() => handlePageChange(pagination.current_page - 1)}
            disabled={!pagination.prev_page_url}
            className={`page-btn arrow-btn ${!pagination.prev_page_url ? "disabled" : ""
              }`}
          >
            <FontAwesomeIcon icon={faChevronLeft} /> {/* Previous Icon */}
          </button>

          {/* Page Numbers */}
          {renderPagination().map((page, index) => (
            <button
              key={index}
              className={`page-btn ${currentPage === page ? "active" : ""}`}
              onClick={() => handlePageChange(page)}
              disabled={page === "..." || page === currentPage}
              style={
                currentPage === page
                  ? {
                    backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
                    color: "white",
                    borderColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
                  }
                  : {}
              }
            >
              {page === "..." ? "..." : page}
            </button>
          ))}


          {/* Next Button with Icon */}
          <button
            onClick={() => handlePageChange(pagination.current_page + 1)}
            disabled={!pagination.next_page_url}
            className={`page-btn arrow-btn ${!pagination.next_page_url ? "disabled" : ""
              }`}
          >
            <FontAwesomeIcon icon={faChevronRight} /> {/* Next Icon */}
          </button>
        </div>
      </div>
      {isOpenQuickViewModal && <QuickView isOpenQuickViewModal={isOpenQuickViewModal} handlecloseQuikViewMOdal={handlecloseQuikViewMOdal} quickViewId={quickViewId} />}
    </div>
  );
}

export default Index;
